import { useDispatch } from 'react-redux';

import checkImage from '@app/assets/icons/icon-check.svg';
import { modalClose } from '@app/store/modal/actions';

function BulkRequestStartedAlert() {
  const dispatch = useDispatch();

  return (
    <div className="Container Container--max-xs">
      <div className="Card Card--pop box-7x align-center">
        <img alt="체크 아이콘" className="space-4x" src={checkImage} />
        <h3 className="space-4x">
          <strong>대량전송이 시작되었습니다</strong>
        </h3>
        <p>
          대량전송이 시작되었습니다.
          <br />
          전송 수에 따라 1분 ~ 60분 정도 소요됩니다.
        </p>
        <p className="space-6x">*브라우저를 종료하셔도 전송은 계속 진행됩니다.</p>
        <button
          className="Btn Btn--bold Btn--primary"
          type="button"
          onClick={() => {
            dispatch(modalClose());
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
}

export default BulkRequestStartedAlert;
